"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = require("react-select");

var _Dropdown = require("./Dropdown.style");

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MenuList = function MenuList(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _props$selectProps = props.selectProps,
      customListHead = _props$selectProps.customListHead,
      customListFoot = _props$selectProps.customListFoot;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledMenuList, null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MenuList, props, customListHead && ( /*#__PURE__*/(0, _react.isValidElement)(customListHead) ? customListHead : /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledCustomHead, null, customListHead)), children, customListFoot && ( /*#__PURE__*/(0, _react.isValidElement)(customListFoot) ? customListFoot : /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledCustomFoot, null, customListFoot))));
};

exports.MenuList = MenuList;
MenuList.propTypes = {
  children: _propTypes["default"].node,
  selectProps: _propTypes["default"].shape({
    customListHead: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    customListFoot: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
  })
};